<script>
import { sanitizeUrl } from '@braintree/sanitize-url';
import { mapAsUrlsAndDomains } from '@/utils/url';
import { iIcon } from '@inscribe/signal';

export default {
  name: 'UrlsDisplayer',
  components: {
    iIcon,
  },
  props: {
    urls: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      mapAsUrlsAndDomains,
      sanitizeUrl,
    };
  },
};
</script>

<template>
  <div
    v-if="urls?.length"
    class="urls-displayer d-flex flex-column i-gap-4"
    data-testid="urls-displayer"
  >
    <div class="i-text-subheading-2 i-text-neutral-120">Sources</div>
    <div
      v-for="({ url, domain }, index) in mapAsUrlsAndDomains(urls)"
      :key="index"
      class="link d-flex align-items-center i-gap-4 i-px-6 i-py-4 i-radius-md"
      data-testid="urls-displayer-item"
    >
      <i-icon symbol="small-link" class="i-text-neutral-90" :size="12"></i-icon>
      <a
        class="d-flex flex-grow-1 i-text-subheading-3 i-text-neutral-120"
        :href="sanitizeUrl(url)"
        target="_blank"
        >{{ sanitizeUrl(domain) }}</a
      >
      <i-icon
        symbol="small-arrows-corner-up-right-small"
        class="i-text-neutral-90"
        :size="12"
      ></i-icon>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.urls-displayer {
  .link {
    border: 1px solid $light-neutral-60;
    cursor: pointer;

    .i-icon {
      min-width: 12px;
    }

    a {
      text-decoration: none;
      overflow: hidden;
    }
  }
}
</style>
